<app-page-heading [heading]="'Issue Management'" [hasBackButton]="false"></app-page-heading>

<div *ngIf="isLoading" class="center-container">
  <mat-spinner></mat-spinner>
</div>

<div class="page-container">
  <mat-grid-list cols="4" rowHeight="100px">
    <mat-grid-tile>
      <mat-form-field class="w-90">
        <mat-label>Search for an issue by name</mat-label>
        <input #ticketSearch matInput type="text" [formControl]="ticketNameFormControl"
               (input)="onInputChangedSearchTicketsByName($event)">
      </mat-form-field>
    </mat-grid-tile>

    <mat-grid-tile>
      <mat-form-field class="w-90">
        <mat-label>Issue Status</mat-label>
        <mat-select [id]="ticketSortFilterValue.STATUS"
                    [formControl]="ticketStatusFormControl"
                    (selectionChange)="searchForTicketsByStatusOrManager()">
          <mat-option *ngFor="let status of statuses" [value]="status.name">
            {{status.name}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </mat-grid-tile>

    <mat-grid-tile>
      <mat-form-field class="w-90">
        <mat-label>Issue Manager</mat-label>
        <mat-select [id]="ticketSortFilterValue.ASSIGNEE_LAST_NAME"
                    [formControl]="ticketAssigneeFormControl"
                    (selectionChange)="searchForTicketsByStatusOrManager()">
          <mat-option *ngFor="let assignee of assignees" [value]="assignee.name">
            {{assignee.name}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </mat-grid-tile>

    <mat-grid-tile class="flex-end">
      <button class="button-spacer" (click)="openTicketDialog()" mat-raised-button
              color="accent">
        <mat-icon>add</mat-icon>
        Add Issue
      </button>
    </mat-grid-tile>
  </mat-grid-list>

  <div *ngIf="ticketDataSource" class="mat-elevation-z8 table-container">

    <table mat-table multiTemplateDataRows [dataSource]="ticketDataSource" #ticketSort="matSort" matSort
           (matSortChange)="sortData($event)">

      <ng-container matColumnDef="icons">
        <th *matHeaderCellDef mat-header-cell></th>
        <td *matCellDef="let row" mat-cell>
          <mat-icon class="table-icon" matTooltip="EDIT Issue" (click)="editEntry($event, row.issueTicketId)">edit
          </mat-icon>
          <mat-icon class="table-icon" matTooltip="DELETE Issue" (click)="deleteEntry($event, row.issueTicketId)">
            delete
          </mat-icon>
        </td>
      </ng-container>

      <ng-container matColumnDef="name">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Issue Name</th>
        <td style="width: 350px;" *matCellDef="let row" mat-cell>{{row.name}}</td>
      </ng-container>

      <ng-container matColumnDef="assignee">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Assignee</th>
        <td *matCellDef="let row" mat-cell>{{row.assignee?.name}}</td>
      </ng-container>

      <ng-container matColumnDef="reporter">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Reporter</th>
        <td *matCellDef="let row" mat-cell>{{row.reporter?.name}}</td>
      </ng-container>

      <ng-container matColumnDef="module">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Module</th>
        <td *matCellDef="let row" mat-cell>{{row.module?.name}}</td>
      </ng-container>

      <ng-container matColumnDef="priority">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Priority</th>
        <td *matCellDef="let row" mat-cell>{{row.priority?.name}}</td>
      </ng-container>

      <ng-container matColumnDef="startDate">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Start Date</th>
        <td *matCellDef="let row" mat-cell>{{row.startDate | date: dateFormat}}</td>
      </ng-container>

      <ng-container matColumnDef="endDate">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>End Date</th>
        <td *matCellDef="let row" mat-c ell>{{row.endDate | date: dateFormat}}</td>
      </ng-container>

      <ng-container matColumnDef="dueDate">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Due Date</th>
        <td *matCellDef="let row" mat-cell>{{row.dueDate | date: dateFormat}}</td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Status</th>
        <td *matCellDef="let row" mat-cell>{{row.status?.name}}</td>
      </ng-container>

      <ng-container matColumnDef="resolution">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Resolution</th>
        <td *matCellDef="let row" mat-cell>{{row.resolution?.name}}</td>
      </ng-container>

      <ng-container matColumnDef="expandedDetail">
        <td *matCellDef="let row" mat-cell [attr.colspan]="ticketDisplayedColumns.length">
          <div class="row-detail-container" [@detailExpand]="row == ticketExpandedRow ? 'expanded' : 'collapsed'">
            <b>Created By: </b>{{row.createdBy}}<br>
            <b>Created Date: </b>{{row.created | date: dateTimeFormat}}<br>
            <b>Updated By: </b>{{row.updatedBy}}<br>
            <b>Updated Date: </b>{{row.updated | date: dateTimeFormat}}<br>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="ticketDisplayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: ticketDisplayedColumns;" class="row"
          [class.expanded-row]="ticketExpandedRow == row"
          (click)="ticketExpandedRow = ticketExpandedRow === row ? null : row">
      </tr>
      <tr mat-row *matRowDef="let row; columns: ['expandedDetail'];" class="detail-row"></tr>

    </table>

    <mat-paginator #ticketPaginator (page)="pageChanged($event)" [length]="ticketTableControl.length"
                   [pageSize]="ticketTableControl.pageSize" [pageIndex]="0"
                   [pageSizeOptions]="ticketTableControl.pageSizeOptions">
    </mat-paginator>

  </div>
</div>
